module.exports = __webpack_public_path__ + "static/media/logo1.10fd4c1b.png";